export default __webpack_public_path__ + "static/media/logo.a393f4a9.png";